import { memo, useCallback, useEffect, useRef, useState } from 'react'
import PaymentAggregator from '../PaymentAggregator'
import { getApiDataProgressPayment, liveUrl } from '../APIHelper'
import PaymentStatus from '../PaymentStatus'
import PaymentStatusPage from '../PaymentStatusPage'
import { Typography } from '@mui/material'
import { BRANDING_KEYS, BrandHeader, PoweredBy, applyBackendBranding, getBranding } from '../Branding'
import CheckoutSkeleton from '../CheckoutSkeleton'
import { isEmpty, pick } from 'lodash'
import { checkNull, redirectToUrl } from '../../Helpers'
import { Strings } from '../../Strings'
import './styles.css'

// PaymentAggregator re-runs its setup (currency, product details, login) on every
// render, so it must not re-render when HomePage only updates the branding
const MemoPaymentAggregator = memo(PaymentAggregator)

const HomePage = (props) => {
  let params = new URL(document.location.toString()).searchParams
  let id = params.get('id')
  let payment_link_id = params.get('payment_link_id')

  // Check if the URL matches /payment-status/:transaction_code/:order_code
  const pathSegments = window.location.pathname.split('/').filter(Boolean)
  const isPaymentStatusRoute = pathSegments[0] === 'payment-status' && pathSegments.length >= 3
  const routeTransactionCode = isPaymentStatusRoute ? pathSegments[1] : null
  const routeOrderCode = isPaymentStatusRoute ? pathSegments[2] : null

  const [data, setData] = useState({
    payObj: {},
    status: false,
    message: '',
    initialStatus: false,
    orderStatus: Strings.fail,
  })
  const staticData = {
    PaymentType: '', //require => one_time, subscription, custom_subscription
    paymentData: {
      name: 'Ronak',
      amount: 50,
      email: '',
      country_code: 'IN',
      toCountryCode: 'IN',
      app_token:
        'app_5B7768DA83B0AE019F437C0CCD61C5EE52A9ED60F3A566EBE1F286009B61',
      currency: 'INR',
      address:"",
      transaction_code: 'txn_1234567',
      mobile: '',
      payThroughEMI: false,
      payThroughRecurrence: false,
      updateSubscription: false, //for update subscription like cancel,pause,resume,update payment Method,
      //for razorpay there is no update payment method
      updateSubscriptionType: 'paymentMethod', //cancel,pause,resume,paymentMethod (required if updateSubscription=true)
      recurrenceObj: {
        intervalType: 'monthly', //weekly,monthly,yearly
        //default is 1
        interval_count: 1, //if interval_count=2 then it is for every 2 (months,week,year)
        //default is 0 means forever
        iterations: 0, //if suppose iteration is 2 then it will charge 2 (months,week,year)
        start_at: '', //in local date time format for future subscription schedule
        order_code: '08D2665B0B8B0BB104845056E7B12911F29573259DE8156338', //required for update payment method
      },
       isWebview: false, // Set to true if the app is running inside a WebView
    }, //require
    onPaymentDone: () => {
      // setTimeout(() => setPaySuccess(false), 3000)
    },
    onCloseClick: () => {
      console.log('closed')
    },
    // appCharges: [ ],
    noCharge: false,
    pluginURL: 'staging', //staging, dev, prodapi
    // changeBtnText is computed dynamically in PaymentAggregator based on paymentData flags
    showHeader: true,

    // For gradient
    isGradientButton: true,
    linearColorsName: ['#0BBCED', '#1252A5'],
    //backgroundcolor of the page, default is white
    themeColor: '#FFFFFF',

    // Branding — all optional. Set per app in the AautiPay portal (returned by the
    // getIframe / get-payment-link / login APIs as `branding`), which wins over props.
    // primaryColor, headerText, headerColor, headerTextColor, loaderColor
    // changeBtnText: pay button text, default is Pay / Subscribe / Update (Proceed for payment links)
  }
  // branding saved in the AautiPay portal for this app. Whichever API returns it
  // first (getIframe / get-payment-link / login) updates the whole page.
  const [backendBranding, setBackendBranding] = useState(null)
  // stable, and skips identical branding, so updates from several APIs don't loop
  const updateBranding = useCallback((branding) => {
    if (!branding || typeof branding !== 'object') return
    setBackendBranding((prev) =>
      JSON.stringify(prev) === JSON.stringify(branding) ? prev : branding
    )
  }, [])
  // branding for the screens HomePage renders itself (loader / error / status)
  const brand = getBranding(applyBackendBranding({ ...staticData, ...props }, backendBranding))

  // redirect_url comes from the payment link API; a ref so it's readable
  // straight away, without waiting for a state update
  const redirectUrlRef = useRef(null)

  // redirect applies only to the payment-link flow
  const isPaymentLinkFlow = !isEmpty(payment_link_id)

  const redirectToPage = () => {
    if (!isPaymentLinkFlow) return
    redirectToUrl(redirectUrlRef.current)
  }

  const onPaymentDone = (payload = 'success') => {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage((payload));
    } else {
      console.warn("Not inside a WebView context");
    }
    redirectToPage(payload)
    props?.onPaymentDone?.(payload)
  }
  async function callApi() {
    setData((prev) => ({ ...prev, status: true }))
    //  setPageLoader(true)
    try {
      // Step 3: Make an asynchronous API request to the login endpoint
      const response = await getApiDataProgressPayment(
        `${liveUrl}getIframe/${id}`, // URL for the login endpoint
        'GET'
      )
      if (response?.status == false || checkNull(response)) {
        //  setPageLoader(false)
        setData((prev) => ({
          ...prev,
          status: false,
          initialStatus: true,
          message: Strings.went_wrong,
        }))
      } else {
        const res = response?.data
        updateBranding(res?.branding)
        const data = applyBackendBranding({
          ...staticData,
          ...res,
          paymentData: { ...staticData?.paymentData, ...res?.paymentData, app_token: (res?.paymentData?.app_token || staticData?.paymentData?.app_token || '').trim() },
        }, res?.branding)
        setData((prev) => ({
          ...prev,
          payObj: data,
          status: false,
        }))
      }
    } catch (error) {
      setData((prev) => ({
        ...prev,
        initialStatus: true,
        message: error?.message,
      }))
      console.log('error:', error)
    }
  }

  async function callPaymentLinkApi() {
    setData((prev) => ({ ...prev, status: true }))
    try {
      const response = await getApiDataProgressPayment(
        `${liveUrl}get-payment-link/${payment_link_id}`,
        'GET'
      )
      if (response?.status == false || checkNull(response)) {
        setData((prev) => ({
          ...prev,
          status: false,
          initialStatus: true,
          message: response?.message || Strings.went_wrong,
        }))
      } else {
        const res = response?.data
        redirectUrlRef.current = res?.redirect_url
        updateBranding(res?.branding)
        const retryStatuses = [null, 'pending', 'failed']

        // if status allows retry or no order yet — show payment form
        if (retryStatuses.includes(res?.order_status)) {
          // falls through to show payment form below
        } else {
          // map backend status to PaymentStatus component status
          const statusMap = {
            'success': 'success',
            'subscription created': Strings.subscriptionSuccess,
          }
          const orderStatus = statusMap[res?.order_status] || 'done'
          setData((prev) => ({
            ...prev,
            status: false,
            initialStatus: true,
            orderStatus,
            message: orderStatus === 'done' ? "You've either completed your payment or this checkout session has timed out." : '',
          }))
          // the order is final here, so notify the host app and hand the user
          // over to the payment link's redirect_url, whatever the status is
          onPaymentDone("success")
          return
        }
        // show payment form
        const payData = applyBackendBranding({
          ...staticData,
          paymentData: {
            ...staticData?.paymentData,
            name: res?.name,
            email: res?.email,
            mobile: res?.mobile,
            address: res?.address,
            amount: res?.amount,
            country_code: res?.country_code,
            currency: res?.currency,
            app_token: (res?.app_token || '').trim(),
            transaction_code: res?.transaction_code,
            payThroughEMI: res?.payThroughEMI,
            payThroughRecurrence: res?.payThroughRecurrence,
            updateSubscription: res?.updateSubscription,
            updateSubscriptionType: res?.updateSubscriptionType,
            recurrenceObj: res?.recurrenceObj || staticData?.paymentData?.recurrenceObj,
          },
          chargeAsFixedAmount: res?.chargeAsFixedAmount,
          saveCard: res?.saveCard,
          order_details: res?.order_details,
          pl_code: payment_link_id,
          redirect_url: res?.redirect_url,
        }, res?.branding)
        setData((prev) => ({
          ...prev,
          payObj: payData,
          status: false,
        }))
      }
    } catch (error) {
      setData((prev) => ({
        ...prev,
        initialStatus: true,
        message: error?.message,
      }))
      console.log('error:', error)
    }
  }

  // Check if this is a payment status or subscription status route — delegate to PaymentStatusPage
  const isPaymentStatusDelegated = (isPaymentStatusRoute && routeOrderCode) || !isEmpty(params.get('order_code'))
  const delegatedOrderCode = isPaymentStatusRoute ? routeOrderCode : params.get('order_code')
  const delegatedIsSubscription = !isEmpty(params.get('order_code'))

  useEffect(() => {
    if (isPaymentStatusDelegated) {
      // PaymentStatusPage handles its own loading/fetching
      return
    }
    setData((prev) => ({ ...prev, status: true }))
    if (!isEmpty(params.get('payment_link_id'))) {
      callPaymentLinkApi()
    }
    else if (!isEmpty(params.get('id'))) {
      callApi()
    }
    else if (!isEmpty(props)) {
      setData((prev) => ({
        ...prev,
        payObj: props,
        status: false,
      }))
    }
    else {
      setData((prev) => ({ ...prev, initialStatus: true, status: false }))
    }
  }, [])

  // Delegate payment status / subscription status routes to PaymentStatusPage
  if (isPaymentStatusDelegated) {
    return (
      <div
        className="homePageContainer"
        style={{ backgroundColor: brand.themeColor, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
      >
        <PaymentStatusPage
          orderCode={delegatedOrderCode}
          isSubscription={delegatedIsSubscription}
          redirectUrl={redirectUrlRef.current}
          // raw values, not the resolved `brand`: resolved defaults (e.g. headerColor)
          // would block the merchant's saved primaryColor from flowing into them
          {...pick({ ...staticData, ...props }, BRANDING_KEYS)}
          onPaymentDone={onPaymentDone}
        />
      </div>
    )
  }

  return (
    <div
      className="homePageContainer"
      style={{ backgroundColor: brand.themeColor, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
    >
      {data?.status ? (
        // details and the merchant's branding are not loaded yet
        <CheckoutSkeleton
          variant={isPaymentLinkFlow ? 'summary' : 'paymentMethod'}
          // same rule as PaymentAggregator's header, so the layout doesn't jump
          showHeader={(props?.showHeader ?? staticData.showHeader) && !params.get('isMobile')}
        />
      ) : !isEmpty(data?.payObj) && Object.keys?.(data?.payObj)?.length > 0 ? (
        <div style={{ backgroundColor: brand.themeColor, flex: 1, width: '100%', display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>
          <MemoPaymentAggregator {...data?.payObj} onBrandingLoaded={updateBranding} />
        </div>
      ) : (
        <>
          {data?.initialStatus ? (
            <div
              style={{
                display: 'flex',
                flex: 1,
                width: '100%',
                flexDirection: 'column',
                backgroundColor: brand.themeColor,
                overflow: 'hidden',
              }}
            >
              {/* Header */}
              <BrandHeader text={brand.headerText} color={brand.headerColor} textColor={brand.headerTextColor} fontWeight={700} />
              {/* Content — scrollable middle */}
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  minHeight: 0,
                }}
              >
                <PaymentStatus
                  primaryColor={brand.primaryColor}
                  loaderColor={brand.loaderColor}
                  status={data?.orderStatus ?? Strings.fail}
                  message={
                    checkNull(data?.message)
                      ? 'Authentication Failed'
                      : data?.message
                  }
                />
              </div>
              {/* Footer */}
              <PoweredBy color={brand.primaryColor} />
            </div>
          ) : isEmpty(data?.payObj) && !data?.initialStatus ? (
            <div
              style={{
                display: 'flex',
                flex: 1,
                width: '100%',
                flexDirection: 'column',
                backgroundColor: brand.themeColor,
              }}
            >
              {/* Header */}
              <BrandHeader text={brand.headerText} color={brand.headerColor} textColor={brand.headerTextColor} fontWeight={700} />
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography style={{ fontSize: 15, fontWeight: 500, color: '#1a1a2e' }}>
                  No Data
                </Typography>
              </div>
            </div>
          ) : null}
        </>
      )}
    </div>
  )
}

export default HomePage
